import styled from 'styled-components'
import {Link} from 'react-router-dom'



export const CardsWrapper = styled.div`
    margin: 100px auto 0;
    width: fit-content;
`

export const ColumnWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25vw;
    height: 40vh;
    margin: 10px;
    background-color: #212121;
    @media screen and (max-width: 768px) {
        height: 100%;
        padding: 20px 0;
    }

`

export const DescWrapper = styled.div`
    text-align: center;
    font-weight: 500;
    font-size: 36px;
    padding: 20px 40px;

    @media screen and (max-width: 768px) {
        padding: 5px;
        font-size: 20px;
    }
`

export const Button = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12vw;
    height: 6vh;
    margin: 0 auto;
    border: 2px solid #FF4C00;
    color: #fff;
    background-color: inherit;
    font-family: ${({font}) => (font==='') ? 'inherit' : font};
    font-size: 24px;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.9;
    align-self: ${({img_first}) => img_first ? 'inherit' : 'flex-end'};

    @media screen and (max-width: 768px) {
        margin: 0 auto;
        width: 30vw;
        height: 4vh;
        font-size: 15px;
        line-height: 3vh;
        padding: 0.27vh 0;
        width: 80px;

    }


    @media screen and (max-width: 480px) {
        font-size: 8px;
        width: 50px;
        height: 30px;
    }
    &:hover, &:active {
        text-decoration: none;
        color: white;
    }

    &:hover{
        text-decoration: none;

        background-color: #FF4C00;
        opacity: 1;
    }

    &:active{
        background-color: #FF4C00;
        opacity: 1.2;
    }

`


